// External
import { NgModule } from '@angular/core';

// Internal
import { BusinessAssetsSvgComponent } from './business-assets-svg.component';
import { CommonModule } from '@angular/common';
import { UiIconModule } from '../../../common/components/ui/ui-icon/ui-icon.module';

@NgModule({
    declarations: [BusinessAssetsSvgComponent],
    imports: [
        CommonModule,
        UiIconModule
    ],
    exports: [BusinessAssetsSvgComponent]
})

export class BusinessAssetsSvgModule {}